import React from "react"
import { CloseIcon, PencilIcon } from "../../Icons"

export default class MultipleImageFieldThumb extends React.Component {
  state = {
    loading: false,
    hash: Date.now()
  }

  render() {
    const { url } = this.props

    if (!url) {
      return null
    }
    return (
      <div className="thumb">
        <span className="thumb-hover">
          <span className="closeIcon" onClick={this.props.handleDeleteImage}>
            <CloseIcon />
          </span>
          <span className="editContainer">
            <span className="editIcon" onClick={this.props.onClick}>
              <PencilIcon />
            </span>
          </span>
        </span>
        <img src={`${url}`} alt={url} height={200} width={200} />
      </div>
    )
  }
}
